export default function FormatNumber({value, empty='' }) {
    return (value || value === 0) ? `${value.toLocaleString("en-US")}` : empty
}
